import React, { useState } from 'react';
import { X } from 'lucide-react';
import { getCurrentPort, updatePort } from './config';

export default function Settings({ onClose }) {
  const [port, setPort] = useState(getCurrentPort());
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');

    // Validate port number
    const portNum = parseInt(port);
    if (isNaN(portNum) || portNum < 1024 || portNum > 65535) {
      setError('Port must be a number between 1024 and 65535');
      return;
    }

    updatePort(portNum);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-panel max-w-sm p-6">
        <div className="mb-4 flex items-center justify-between">
          <h2 className="font-display text-lg font-semibold text-ink">API settings</h2>
          <button
            onClick={onClose}
            aria-label="Close"
            className="-mr-1 rounded-md p-1.5 text-ink-soft transition-colors hover:bg-surface-alt hover:text-ink"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="label" htmlFor="api-port">API port</label>
            <input
              id="api-port"
              type="number"
              value={port}
              onChange={(e) => setPort(e.target.value)}
              className="input"
              placeholder="Enter port number"
            />
            {error && <p className="mt-1.5 text-sm text-danger">{error}</p>}
          </div>

          <div className="flex justify-end gap-3">
            <button type="button" onClick={onClose} className="btn-ghost">
              Cancel
            </button>
            <button type="submit" className="btn-primary">
              Save changes
            </button>
          </div>
        </form>
      </div>
    </div>
  );
} 